import React from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import type InvoiceSetting from '@this/domain/organization/invoice_setting';

interface Props {
  setting: InvoiceSetting;
}

const InvoiceSettingForm: React.FC<Props> = ({ setting }) => (
  <>
    <div style={{ marginBottom: '10px' }}>
      <label>請求締め日</label>
      <div className="flex">
        <select value={setting.fromMonth} disabled>
          <option value="N">N</option>
          <option value="N-1">N-1</option>
        </select>
        <span>月</span>
        <select value={setting.fromDay} disabled>
          {_.range(1, 32).map(value => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        <span>日</span>
        <span>〜</span>
        <select value={setting.toMonth} disabled>
          <option value="N">N</option>
        </select>
        <span>月</span>
        <select value={setting.toDay} disabled>
          {_.range(1, 32).map(value => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        <span>日</span>
      </div>
    </div>
    <div style={{ marginBottom: '10px' }}>
      <label>請求書自動発行日</label>
      <div className="flex">
        <select value={setting.autoCreateMonth || ''} disabled>
          <option value="">-</option>
          <option value="N+1">N+1</option>
          <option value="N+2">N+2</option>
        </select>
        <span>月</span>
        <select value={setting.autoCreateDay || ''} disabled>
          <option value="">-</option>
          {_.range(1, 32).map(value => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        <span>日</span>
      </div>
    </div>
    <div style={{ marginBottom: '10px' }}>
      <label>支払期日</label>
      <div className="flex">
        <select value={setting.paymentExpiredMonth || ''} disabled>
          <option value="N+1">N+1</option>
          <option value="N+2">N+2</option>
          <option value="N+3">N+3</option>
        </select>
        <span>月</span>
        <select value={setting.paymentExpiredDay || ''} disabled>
          {_.range(1, 32).map(value => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        <span>日</span>
      </div>
    </div>
    <div style={{ marginBottom: '10px' }}>
      <label>請求発行締切日</label>
      <div className="flex" style={{ alignItems: 'center' }}>
        <div
          style={{
            padding: '4px 8px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            minHeight: '24px',
            width: '3em',
            marginBottom: 0
          }}
        >
          {setting.closingDay || '-'}
        </div>
        <span>営業日</span>
      </div>
    </div>
    <div style={{ marginBottom: '10px' }}>
      <label>請求時メモ</label>
      <div
        style={{
          padding: '4px 8px',
          backgroundColor: '#f5f5f5',
          borderRadius: '4px',
          minHeight: '24px',
          whiteSpace: 'pre-wrap'
        }}
      >
        {setting.memo || ''}
      </div>
    </div>
  </>
);

export default observer(InvoiceSettingForm);
